import { useEffect, useState } from 'react';
import styles from './LoginPage.module.css';
import integration from 'services/integration';
import { useLanguageService } from 'translations';
import { prepareUrl } from 'helpers';
import Header from 'components/Header/Header';
import auth from 'services/auth';
import { useNavigate } from 'react-router-dom';

const WidgetPage = () => {
  const { lang, langCodes } = useLanguageService();
  const [query, setQuery] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    integration
      .init({
        languages: langCodes,
        isNavigationCaptureDisabled: true,
      })
      .on('navigation', (data) => {
        if (data.path === '/' || data.previousPath === '/mini-iframe') {
          navigate('/');
        }
      });
  }, [langCodes, navigate]);

  useEffect(() => {
    async function applyQuery(token) {
      try {
        const user = await auth.getUser(token);
        const query = new URLSearchParams({
          jwt: user.jwt.jwt,
        });
        setQuery(query.toString());
      } catch (e) {}
    }
    let token = localStorage.getItem('token');
    if (token) {
      applyQuery(token);
    }
  }, []);

  const url = prepareUrl(lang) + '/mini-iframe?' + query;
  useEffect(() => {
    integration.mount('frame', url);
  }, [url]);

  return (
    <div className={styles.widget}>
      <Header hideControls />
      <div id="frame"></div>
    </div>
  );
};

export default WidgetPage;
